module.exports = "/lucky-balls/img/drum/drum_loop_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_021.png
// module id = 1036
// module chunks = 0